/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SummaryBankSourceResponse
 */
export interface SummaryBankSourceResponse {
    /**
     * 
     * @type {string}
     * @memberof SummaryBankSourceResponse
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof SummaryBankSourceResponse
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof SummaryBankSourceResponse
     */
    total?: number;
    /**
     * 
     * @type {number}
     * @memberof SummaryBankSourceResponse
     */
    count?: number;
}

/**
 * Check if a given object implements the SummaryBankSourceResponse interface.
 */
export function instanceOfSummaryBankSourceResponse(value: object): value is SummaryBankSourceResponse {
    return true;
}

export function SummaryBankSourceResponseFromJSON(json: any): SummaryBankSourceResponse {
    return SummaryBankSourceResponseFromJSONTyped(json, false);
}

export function SummaryBankSourceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SummaryBankSourceResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'type': json['type'] == null ? undefined : json['type'],
        'total': json['total'] == null ? undefined : json['total'],
        'count': json['count'] == null ? undefined : json['count'],
    };
}

export function SummaryBankSourceResponseToJSON(json: any): SummaryBankSourceResponse {
    return SummaryBankSourceResponseToJSONTyped(json, false);
}

export function SummaryBankSourceResponseToJSONTyped(value?: SummaryBankSourceResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'type': value['type'],
        'total': value['total'],
        'count': value['count'],
    };
}

